export const REPORT_GET_SALE_REPORT_ACTION = "REPORT_GET_SALE_REPORT_ACTION";
export const REPORT_GET_SALE_REPORT_SUCCESS = "REPORT_GET_SALE_REPORT_SUCCESS";
export const REPORT_VOUCHER_REDEEMTION_ACTION = "REPORT_VOUCHER_REDEEMTION_ACTION";
export const REPORT_VOUCHER_REDEEMTION_SUCCESS = "REPORT_VOUCHER_REDEEMTION_SUCCESS";
export const REPORT_VOUCHER_REDEEMTION_DETAIL_ACTION = "REPORT_VOUCHER_REDEEMTION_DETAIL_ACTION";
export const REPORT_VOUCHER_REDEEMTION_DETAIL_SUCCESS = "REPORT_VOUCHER_REDEEMTION_DETAIL_SUCCESS";

export const REPORT_EXPORT_REDEEMTIONS_ACTION = "REPORT_EXPORT_REDEEMTIONS_ACTION";
export const REPORT_EXPORT_REDEEMTIONS_FAIL = "REPORT_EXPORT_REDEEMTIONS_FAIL";
export const REPORT_EXPORT_REDEEMTIONS_SUCCESS = "REPORT_EXPORT_REDEEMTIONS_SUCCESS";

export const REPORT_GET_SALE_REPORT_BY_ORDER_ACTION = "REPORT_GET_SALE_REPORT_BY_ORDER_ACTION";
export const REPORT_GET_SALE_REPORT_BY_ORDER_SUCCESS = "REPORT_GET_SALE_REPORT_BY_ORDER_SUCCESS";

export const REPORT_GET_SALE_REPORT_BY_SKU_ACTION = "REPORT_GET_SALE_REPORT_BY_SKU_ACTION";
export const REPORT_GET_SALE_REPORT_BY_SKU_SUCCESS = "REPORT_GET_SALE_REPORT_BY_SKU_SUCCESS";

export const REPORT_GET_SALE_DETAIL_REPORT_BY_SKU_ACTION = "REPORT_GET_SALE_DETAIL_REPORT_BY_SKU_ACTION";
export const REPORT_GET_SALE_DETAIL_REPORT_BY_SKU_SUCCESS = "REPORT_GET_SALE_DETAIL_REPORT_BY_SKU_SUCCESS";

export const REPORT_GET_CASH_FLOW_REPORT_ACTION = "REPORT_GET_CASH_FLOW_REPORT_ACTION";
export const REPORT_GET_CASH_FLOW_REPORT_SUCCESS = "REPORT_GET_CASH_FLOW_REPORT_SUCCESS";

export const REPORT_GET_COLLABORATOR_REPORT_ACTION = "REPORT_GET_COLLABORATOR_REPORT_ACTION";
export const REPORT_GET_COLLABORATOR_REPORT_SUCCESS = "REPORT_GET_COLLABORATOR_REPORT_SUCCESS";

export const REPORT_EXPORT_COLLABORATOR_REPORT_ACTION = "REPORT_EXPORT_COLLABORATOR_REPORT_ACTION";
export const REPORT_EXPORT_COLLABORATOR_REPORT_SUCCESS = "REPORT_EXPORT_COLLABORATOR_REPORT_SUCCESS";
export const REPORT_EXPORT_COLLABORATOR_REPORT_FAIL = "REPORT_EXPORT_COLLABORATOR_REPORT_FAIL";

export const REPORT_GET_SALE_DETAIL_REPORT_BY_HOTEL_ACTION = "REPORT_GET_SALE_DETAIL_REPORT_BY_HOTEL_ACTION";
export const REPORT_GET_SALE_DETAIL_REPORT_BY_HOTEL_SUCCESS = "REPORT_GET_SALE_DETAIL_REPORT_BY_HOTEL_SUCCESS";

export const CROSS_CHECK_ACTION = "CROSS_CHECK_ACTION";
export const CROSS_CHECK_SUCCESS = "CROSS_CHECK_SUCCESS";
export const CROSS_CHECK_FAILED = "CROSS_CHECK_FAILED";
export const DEFAULT_CROSS_CHECK_STATUS = "DEFAULT_CROSS_CHECK_STATUS";

export const REPORT_FAIL = "REPORT_FAIL";

export const REPORT_EXPORT_BTB_ORDER_REPORT_FAIL = "REPORT_EXPORT_BTB_ORDER_REPORT_FAIL";
export const REPORT_EXPORT_BTB_ORDER_REPORT_SUCCESS = "REPORT_EXPORT_BTB_ORDER_REPORT_SUCCESS";
export const REPORT_EXPORT_BTB_ORDER_REPORT_ACTION = "REPORT_EXPORT_BTB_ORDER_REPORT_ACTION";
export const REPORT_GET_BTB_ORDER_REPORT_SUCCESS = "REPORT_GET_BTB_ORDER_REPORT_SUCCESS";
export const REPORT_GET_BTB_ORDER_REPORT_ACTION = "REPORT_GET_BTB_ORDER_REPORT_ACTION";
export const REPORT_GET_BTB_USE_ROOM_REPORT_ACTION = "REPORT_GET_BTB_USE_ROOM_REPORT_ACTION";
export const REPORT_GET_BTB_USE_ROOM_REPORT_SUCCESS = "REPORT_GET_BTB_USE_ROOM_REPORT_SUCCESS";

export const REPORT_EXPORT_BTB_USE_ROOM_REPORT_ACTION = "REPORT_EXPORT_BTB_USE_ROOM_REPORT_ACTION";
export const REPORT_EXPORT_BTB_USE_ROOM_REPORT_SUCCESS = "REPORT_EXPORT_BTB_USE_ROOM_REPORT_SUCCESS";
export const REPORT_EXPORT_BTB_USE_ROOM_REPORT_FAIL = "REPORT_EXPORT_BTB_USE_ROOM_REPORT_FAIL";
